var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-a-o": "",
    className: "s-flower home-1__icon",
    style: {
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0V68",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 33.9995H0",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2876 1.13379L42.706 66.865",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8651 25.2908L1.13477 42.7092",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0516 1.22656L24.9492 66.7736",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7736 43.0512L1.22656 24.9487",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4533 4.81885L16.5557 63.1812",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1821 51.4489L4.81982 16.5513",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0607 9.9751L9.94385 58.0248",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0228 58.0585L9.97314 9.94165",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1397 16.4749L4.86816 51.524",
    stroke: "#472425",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5228 63.1358L16.4736 4.86426",
    stroke: "#472425",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.b9aa5e11614c4adc09a5c5911b917f12.svg";
export { ForwardRef as ReactComponent };